export default {
    apiUrl : "https://cruzmanueltech.com/"
    // apiUrl: "http://localhost:3001/"
}